module.exports = "../dist/img/white-.34ad.jpg";